import Table from 'rc-table';
import {APP_URL, IMG_URL, amount_format,} from '../config/Common'
import { Link  } from "react-router-dom";
import { BiRupee } from "react-icons/bi";

const CartTable = (props) => {
   const {cart} = props

   const OrderItemList = (record: any) => {
      return (
         <div className="flex items-center">
            <div className="relative flex h-16 w-16 shrink-0 overflow-hidden rounded">
               {
               record.product.product_image
               ?
               <img
                  src={`${IMG_URL}${record.product.product_image}`}
                  className="h-full w-full object-contain"
                  alt={record.product.product_name}
               />
               :
               <img
                  src={`${APP_URL}/img/no-image-available.png`}
                  className="h-full w-full object-contain"
                  alt={record.product.product_name}
               />
               }
            </div>
            <div className="flex flex-col overflow-hidden ltr:ml-4 rtl:mr-4">
               <div className="mb-1 flex space-x-1 rtl:space-x-reverse">
                  <Link to={`/product/${record.product.product_slug}`} className="inline-block overflow-hidden truncate text-sm text-body transition-colors hover:text-accent hover:underline">
                     {record.product.product_name}
                  </Link>
                  <span className="inline-block overflow-hidden truncate text-sm text-body">
                     x
                  </span>
                  <span className="inline-block overflow-hidden truncate text-sm font-semibold text-heading">
                     {record.quantity} item
                  </span>
               </div>
               <span className="mb-1 inline-block overflow-hidden truncate text-sm font-semibold text-accent flex items-center">
                  {amount_format(record.amount)}
               </span>
            </div>
         </div>
      )
   }   

   const columns = [
      {
         title: <span className="ltr:pl-20 rtl:pr-20">Item</span>,
         dataIndex: '',
         key: 'items',
         width: 200,
         ellipsis: true,
         align: 'left',
         render: OrderItemList,
       },
       {
         title: 'Quantity',
         dataIndex: '',
         key: 'pivot',
         align: 'center',
         width: 100,
         render: (qty) => <p className="text-base">{qty.quantity}</p>,
       },
       {
         title: 'Price',
         dataIndex: '',
         key: 'price',
         align: 'right',
         width: 100,
         render: (pivot) => <p className="flex items-center justify-end">{amount_format(pivot.amount)}</p>,
       },       
    ];

   return (
      <>
      <Table 
         columns={columns} 
         data={cart} 
         className="orderDetailsTable w-full"
         rowKey={(record:any) => record.cart_id}
         scroll={{ x: 600, y: 500 }}
         />
      </>
   )

}

export default CartTable;